import React, {useState} from 'react';
import IncludeScript from '../components/IncludeScript';
import Header from '../components/Header';
import Footer from '../components/Footer';
import {Link} from 'react-router-dom';
import ContactModal from '../components/ContactModal';
import welcomePic from '../assets/images/bg-welcome2.webp';


interface IMainPageProps {

}

const MainPage = ({}: IMainPageProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="page-index">
    <div className="page">
      <IncludeScript name={'initCarousel'}/>
      <Header />

      <main className="index-main">
        <img className="index-main-pic" src={welcomePic} alt="Welcome" />
      </main>

      <section className="section-news">
        <div className="container">
          <div className="row">
            <div className="col-12">
                <p>Confier la vente de son bien est un moment clé pour tout propriétaire. NewHome Services vous accompagne dans l’estimation et la vente de votre propriété avec une approche claire et éprouvée. Notre mission est de vous guider dans chaque décision afin de <span className="bold">maximiser la valeur</span> de votre maison ou appartement et d’assurer une <span className="bold">vente sereine et réussie</span>.</p>
                <p>Depuis 20 ans, nous mettons à votre disposition une <span className="bold">expertise complète</span> : analyse du potentiel, estimation des travaux, mise en valeur, stratégie de commercialisation, conseil financier et pilotage du processus de vente.</p>
                <p>Notre connaissance du marché romand et notre rôle de véritable <span className="bold">conseiller immobilier</span> font de nous un partenaire fiable et engagé. Nous plaçons l’écoute, la transparence et la satisfaction de nos clients au cœur de notre mission. Parce que chaque projet est unique, nous vous offrons une approche personnalisée, transparente et orientée résultats. <span className="bold">Votre satisfaction est notre mission.</span></p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-announce">
          <div className="container">
            <div className="announce-block">
                <article className="announce-text">
                <div className="text">
                        <p className="title">Le chantier du projet Symbiose au Mont-sur-Lausanne avance à grands pas.</p>
                        <div>Grâce à une planification rigoureuse et à l’engagement de nos partenaires, la livraison est confirmée pour l’été 2026.</div>
                        En visitant le site, on se rend pleinement compte des volumes et des espaces qui donneront vie à ce nouveau quartier.
                        Ce développement novateur incarne la vision de NewHome Services : créer des quartiers durables, pensés pour la qualité de vie de leurs habitants.
                        Tous les logements ont d’ores et déjà trouvé acquéreur, une belle reconnaissance de la pertinence du projet.
                </div>
                </article>
                <figure className="announce-pic"><img src={require('../assets/images/pic-news.webp')} /></figure>
            </div>
          </div>
      </section>

      <section className="section-carousel">
        <div className="section-carousel_left">
          <div className="owl-carousel owl-theme">
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic1.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic2.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic3.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic4.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic5.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic6.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic7.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic8.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic9.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic10.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic11.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic12.webp')} /></figure>
            </div>
            <div className="item">
              <figure className="carousel-pic"><img src={require('../assets/images/index/pic13.webp')} /></figure>
            </div>
          </div>
        </div>
        <div className="section-carousel_right">
          <div className="section-carousel_more">
            <p className="number">200 +</p>
            <Link to={'/portfolio'}>Voir tous les projets</Link>
          </div>
        </div>
      </section>

      {isOpen && <ContactModal isOpen={isOpen} setOpen={setIsOpen}/>}
      <section className="section-conseil">
        <div className="container">
          <a onClick={() => {
            setIsOpen(true);
            (window as any).dataLayer.push({event: 'contactClick'});
            }
          } className="btn btn-gradient"><span>Contact</span></a>
          <Link to={'/conseil'}><figure className="section-conseil_pic"><img src={require('../assets/images/expertise.svg')} /></figure></Link>
        </div>
      </section>

      <Footer/>
    </div>
    </div>
  )
};

export default MainPage;
